module.exports = __webpack_public_path__ + "fonts/ReadexPro-Regular.7b7b051.ttf";